/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import React from 'react';
import { flexSpotText, flexSpotLink } from '../utils/prop-types';
var HelpText = function HelpText(_ref) {
  var text = _ref.text,
    link = _ref.link,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "cg__overlay__content",
    dangerouslySetInnerHTML: {
      __html: text.html.html
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "cg__overlay__control"
  }, link.link.href.toLowerCase().indexOf('#close') !== -1 && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onClose
  }, link.link.content), link.link.href.toLowerCase().indexOf('#close') === -1 && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      window.location = link.link.href;
    }
  }, link.link.content)));
};
HelpText.propTypes = {
  text: flexSpotText.isRequired,
  link: flexSpotLink.isRequired,
  onClose: PropTypes.func.isRequired
};
export default HelpText;